const NS = 'selectedTab';
export const SET_SELECTED_TAB = `${NS}/SET_SELECTED_TAB`;

export const SELECTEDTAB_INDEX = 0;

export const COLOR = "#3a7bdb";
export const TABCOLORPALETTE= {
            primary: '#3a7bdb',
            primaryDarker: '#154a98',
            secondary: '#89b0e9',
            secondaryDarker: '#346ec5'
        }
